module.exports = __webpack_public_path__ + "images/assets/88806a6a84e68df871565b85510e6c68.svg";